const  data = {
  "AMAZONAS": {
    "BAGUA": {
      "ARAMANGO": true,
      "BAGUA": true,
      "COPALLIN": true,
      "EL PARCO": true,
      "IMAZA": true,
      "LA PECA": true
    },
    "BONGARA": {
      "CHISQUILLA": true,
      "CHURUJA": true,
      "COROSHA": true,
      "CUISPES": true,
      "FLORIDA": true,
      "JAZAN": true,
      "JUMBILLA": true,
      "RECTA": true,
      "SAN CARLOS": true,
      "SHIPASBAMBA": true,
      "VALERA": true,
      "YAMBRASBAMBA": true
    },
    "CHACHAPOYAS": {
      "ASUNCION": true,
      "BALSAS": true,
      "CHACHAPOYAS": true,
      "CHETO": true,
      "CHILIQUIN": true,
      "CHUQUIBAMBA": true,
      "GRANADA": true,
      "HUANCAS": true,
      "LA JALCA": true,
      "LEIMEBAMBA": true,
      "LEVANTO": true,
      "MAGDALENA": true,
      "MARISCAL CASTILLA": true,
      "MOLINOPAMPA": true,
      "MONTEVIDEO": true,
      "OLLEROS": true,
      "QUINJALCA": true,
      "SAN FRANCISCO DE DAGUAS": true,
      "SAN ISIDRO DE MAINO": true,
      "SOLOCO": true,
      "SONCHE": true
    },
    "CONDORCANQUI": {
      "EL CENEPA": true,
      "NIEVA": true,
      "RIO SANTIAGO": true
    },
    "LUYA": {
      "CAMPORREDONDO": true,
      "COCABAMBA": true,
      "COLCAMAR": true,
      "CONILA": true,
      "INGUILPATA": true,
      "LAMUD": true,
      "LONGUITA": true,
      "LONYA CHICO": true,
      "LUYA": true,
      "LUYA VIEJO": true,
      "MARIA": true,
      "OCALLI": true,
      "OCUMAL": true,
      "PISUQUIA": true,
      "PROVIDENCIA": true,
      "SAN CRISTOBAL": true,
      "SAN FRANCISCO DEL YESO": true,
      "SAN JERONIMO": true,
      "SAN JUAN DE LOPECANCHA": true,
      "SANTA CATALINA": true,
      "SANTO TOMAS": true,
      "TINGO": true,
      "TRITA": true
    },
    "RODRIGUEZ DE MENDOZA": {
      "CHIRIMOTO": true,
      "COCHAMAL": true,
      "HUAMBO": true,
      "LIMABAMBA": true,
      "LONGAR": true,
      "MARISCAL BENAVIDES": true,
      "MILPUC": true,
      "OMIA": true,
      "SAN NICOLAS": true,
      "SANTA ROSA": true,
      "TOTORA": true,
      "VISTA ALEGRE": true
    },
    "UTCUBAMBA": {
      "BAGUA GRANDE": true,
      "CAJARURO": true,
      "CUMBA": true,
      "EL MILAGRO": true,
      "JAMALCA": true,
      "LONYA GRANDE": true,
      "YAMON": true
    }
  },
  "ÁNCASH": {
    "AIJA": {
      "AIJA": true,
      "CORIS": true,
      "HUACLLAN": true,
      "LA MERCED": true,
      "SUCCHA": true
    },
    "ANTONIO RAYMONDI": {
      "ACZO": true,
      "CHACCHO": true,
      "CHINGAS": true,
      "LLAMELLIN": true,
      "MIRGAS": true,
      "SAN JUAN DE RONTOY": true
    },
    "ASUNCION": {
      "ACOCHACA": true,
      "CHACAS": true
    },
    "BOLOGNESI": {
      "ABELARDO PARDO LEZAMETA": true,
      "ANTONIO RAYMONDI": true,
      "AQUIA": true,
      "CAJACAY": true,
      "CANIS": true,
      "CHIQUIAN": true,
      "COLQUIOC": true,
      "HUALLANCA": true,
      "HUASTA": true,
      "HUAYLLACAYAN": true,
      "LA PRIMAVERA": true,
      "MANGAS": true,
      "PACLLON": true,
      "SAN MIGUEL DE CORPANQUI": true,
      "TICLLOS": true
    },
    "CARHUAZ": {
      "ACOPAMPA": true,
      "AMASHCA": true,
      "ANTA": true,
      "ATAQUERO": true,
      "CARHUAZ": true,
      "MARCARA": true,
      "PARIAHUANCA": true,
      "SAN MIGUEL DE ACO": true,
      "SHILLA": true,
      "TINCO": true,
      "YUNGAR": true
    },
    "CARLOS FERMIN FITZCARRALD": {
      "SAN LUIS": true,
      "SAN NICOLAS": true,
      "YAUYA": true
    },
    "CASMA": {
      "BUENA VISTA ALTA": true,
      "CASMA": true,
      "COMANDANTE NOEL": true,
      "YAUTAN": true
    },
    "CORONGO": {
      "ACO": true,
      "BAMBAS": true,
      "CORONGO": true,
      "CUSCA": true,
      "LA PAMPA": true,
      "YANAC": true,
      "YUPAN": true
    },
    "HUARAZ": {
      "COCHABAMBA": true,
      "COLCABAMBA": true,
      "HUANCHAY": true,
      "HUARAZ": true,
      "INDEPENDENCIA": true,
      "JANGAS": true,
      "LA LIBERTAD": true,
      "OLLEROS": true,
      "PAMPAS": true,
      "PARIACOTO": true,
      "PIRA": true,
      "TARICA": true
    },
    "HUARI": {
      "ANRA": true,
      "CAJAY": true,
      "CHAVIN DE HUANTAR": true,
      "HUACACHI": true,
      "HUACCHIS": true,
      "HUACHIS": true,
      "HUANTAR": true,
      "HUARI": true,
      "MASIN": true,
      "PAUCAS": true,
      "PONTO": true,
      "RAHUAPAMPA": true,
      "RAPAYAN": true,
      "SAN MARCOS": true,
      "SAN PEDRO DE CHANA": true,
      "UCO": true
    },
    "HUARMEY": {
      "COCHAPETI": true,
      "CULEBRAS": true,
      "HUARMEY": true,
      "HUAYAN": true,
      "MALVAS": true
    },
    "HUAYLAS": {
      "CARAZ": true,
      "HUALLANCA": true,
      "HUATA": true,
      "HUAYLAS": true,
      "MATO": true,
      "PAMPAROMAS": true,
      "PUEBLO LIBRE": true,
      "SANTA CRUZ": true,
      "SANTO TORIBIO": true,
      "YURACMARCA": true
    },
    "MARISCAL LUZURIAGA": {
      "CASCA": true,
      "ELEAZAR GUZMAN BARRON": true,
      "FIDEL OLIVAS ESCUDERO": true,
      "LLAMA": true,
      "LLUMPA": true,
      "LUCMA": true,
      "MUSGA": true,
      "PISCOBAMBA": true
    },
    "OCROS": {
      "ACAS": true,
      "CAJAMARQUILLA": true,
      "CARHUAPAMPA": true,
      "COCHAS": true,
      "CONGAS": true,
      "LLIPA": true,
      "OCROS": true,
      "SAN CRISTOBAL DE RAJAN": true,
      "SAN PEDRO": true,
      "SANTIAGO DE CHILCAS": true
    },
    "PALLASCA": {
      "BOLOGNESI": true,
      "CABANA": true,
      "CONCHUCOS": true,
      "HUACASCHUQUE": true,
      "HUANDOVAL": true,
      "LACABAMBA": true,
      "LLAPO": true,
      "PALLASCA": true,
      "PAMPAS": true,
      "SANTA ROSA": true,
      "TAUCA": true
    },
    "POMABAMBA": {
      "HUAYLLAN": true,
      "PAROBAMBA": true,
      "POMABAMBA": true,
      "QUINUABAMBA": true
    },
    "RECUAY": {
      "CATAC": true,
      "COTAPARACO": true,
      "HUAYLLAPAMPA": true,
      "LLACLLIN": true,
      "MARCA": true,
      "PAMPAS CHICO": true,
      "PARARIN": true,
      "RECUAY": true,
      "TAPACOCHA": true,
      "TICAPAMPA": true
    },
    "SANTA": {
      "CACERES DEL PERU": true,
      "CHIMBOTE": true,
      "COISHCO": true,
      "MACATE": true,
      "MORO": true,
      "NEPEÑA": true,
      "NUEVO CHIMBOTE": true,
      "SAMANCO": true,
      "SANTA": true
    },
    "SIHUAS": {
      "ACOBAMBA": true,
      "ALFONSO UGARTE": true,
      "CASHAPAMPA": true,
      "CHINGALPO": true,
      "HUAYLLABAMBA": true,
      "QUICHES": true,
      "RAGASH": true,
      "SAN JUAN": true,
      "SICSIBAMBA": true,
      "SIHUAS": true
    },
    "YUNGAY": {
      "CASCAPARA": true,
      "MANCOS": true,
      "MATACOTO": true,
      "QUILLO": true,
      "RANRAHIRCA": true,
      "SHUPLUY": true,
      "YANAMA": true,
      "YUNGAY": true
    }
  },
  "APURÍMAC": {
    "ABANCAY": {
      "ABANCAY": true,
      "CHACOCHE": true,
      "CIRCA": true,
      "CURAHUASI": true,
      "HUANIPACA": true,
      "LAMBRAMA": true,
      "PICHIRHUA": true,
      "SAN PEDRO DE CACHORA": true,
      "TAMBURCO": true
    },
    "ANDAHUAYLAS": {
      "ANDAHUAYLAS": true,
      "ANDARAPA": true,
      "CHIARA": true,
      "HUANCARAMA": true,
      "HUANCARAY": true,
      "HUAYANA": true,
      "KAQUIABAMBA": true,
      "KISHUARA": true,
      "PACOBAMBA": true,
      "PACUCHA": true,
      "PAMPACHIRI": true,
      "POMACOCHA": true,
      "SAN ANTONIO DE CACHI": true,
      "SAN JERONIMO": true,
      "SAN MIGUEL DE CHACCRAMPA": true,
      "SANTA MARIA DE CHICMO": true,
      "TALAVERA": true,
      "TUMAY HUARACA": true,
      "TURPO": true
    },
    "ANTABAMBA": {
      "ANTABAMBA": true,
      "EL ORO": true,
      "HUAQUIRCA": true,
      "JUAN ESPINOZA MEDRANO": true,
      "OROPESA": true,
      "PACHACONAS": true,
      "SABAINO": true
    },
    "AYMARAES": {
      "CAPAYA": true,
      "CARAYBAMBA": true,
      "CHALHUANCA": true,
      "CHAPIMARCA": true,
      "COLCABAMBA": true,
      "COTARUSE": true,
      "HUAYLLO": true,
      "JUSTO APU SAHUARAURA": true,
      "LUCRE": true,
      "POCOHUANCA": true,
      "SAN JUAN DE CHACÑA": true,
      "SAÑAYCA": true,
      "SORAYA": true,
      "TAPAIRIHUA": true,
      "TINTAY": true,
      "TORAYA": true,
      "YANACA": true
    },
    "CHINCHEROS": {
      "ANCO-HUALLO": true,
      "CHINCHEROS": true,
      "COCHARCAS": true,
      "HUACCANA": true,
      "OCOBAMBA": true,
      "ONGOY": true,
      "RANRACANCHA": true,
      "URANMARCA": true
    },
    "COTABAMBAS": {
      "CHALLHUAHUACHO": true,
      "COTABAMBAS": true,
      "COYLLURQUI": true,
      "HAQUIRA": true,
      "MARA": true,
      "TAMBOBAMBA": true
    },
    "GRAU": {
      "CHUQUIBAMBILLA": true,
      "CURASCO": true,
      "CURPAHUASI": true,
      "GAMARRA": true,
      "HUAYLLATI": true,
      "MAMARA": true,
      "MICAELA BASTIDAS": true,
      "PATAYPAMPA": true,
      "PROGRESO": true,
      "SAN ANTONIO": true,
      "SANTA ROSA": true,
      "TURPAY": true,
      "VILCABAMBA": true,
      "VIRUNDO": true
    }
  },
  "AREQUIPA": {
    "AREQUIPA": {
      "ALTO SELVA ALEGRE": true,
      "AREQUIPA": true,
      "CAYMA": true,
      "CERRO COLORADO": true,
      "CHARACATO": true,
      "CHIGUATA": true,
      "JACOBO HUNTER": true,
      "JOSE LUIS BUSTAMANTE Y RIVERO": true,
      "LA JOYA": true,
      "MARIANO MELGAR": true,
      "MIRAFLORES": true,
      "MOLLEBAYA": true,
      "PAUCARPATA": true,
      "POCSI": true,
      "POLOBAYA": true,
      "QUEQUEÑA": true,
      "SABANDIA": true,
      "SACHACA": true,
      "SAN JUAN DE SIGUAS": true,
      "SAN JUAN DE TARUCANI": true,
      "SANTA ISABEL DE SIGUAS": true,
      "SANTA RITA DE SIGUAS": true,
      "SOCABAYA": true,
      "TIABAYA": true,
      "UCHUMAYO": true,
      "VITOR": true,
      "YANAHUARA": true,
      "YARABAMBA": true,
      "YURA": true
    },
    "CAMANA": {
      "CAMANA": true,
      "JOSE MARIA QUIMPER": true,
      "MARIANO NICOLAS VALCARCEL": true,
      "MARISCAL CACERES": true,
      "NICOLAS DE PIEROLA": true,
      "OCOÑA": true,
      "QUILCA": true,
      "SAMUEL PASTOR": true
    },
    "CARAVELI": {
      "ACARI": true,
      "ATICO": true,
      "ATIQUIPA": true,
      "BELLA UNION": true,
      "CAHUACHO": true,
      "CARAVELI": true,
      "CHALA": true,
      "CHAPARRA": true,
      "HUANUHUANU": true,
      "JAQUI": true,
      "LOMAS": true,
      "QUICACHA": true,
      "YAUCA": true
    },
    "CASTILLA": {
      "ANDAGUA": true,
      "APLAO": true,
      "AYO": true,
      "CHACHAS": true,
      "CHILCAYMARCA": true,
      "CHOCO": true,
      "HUANCARQUI": true,
      "MACHAGUAY": true,
      "ORCOPAMPA": true,
      "PAMPACOLCA": true,
      "TIPAN": true,
      "UÑON": true,
      "URACA": true,
      "VIRACO": true
    },
    "CAYLLOMA": {
      "ACHOMA": true,
      "CABANACONDE": true,
      "CALLALLI": true,
      "CAYLLOMA": true,
      "CHIVAY": true,
      "COPORAQUE": true,
      "HUAMBO": true,
      "HUANCA": true,
      "ICHUPAMPA": true,
      "LARI": true,
      "LLUTA": true,
      "MACA": true,
      "MADRIGAL": true,
      "MAJES": true,
      "SAN ANTONIO DE CHUCA": true,
      "SIBAYO": true,
      "TAPAY": true,
      "TISCO": true,
      "TUTI": true,
      "YANQUE": true
    },
    "CONDESUYOS": {
      "ANDARAY": true,
      "CAYARANI": true,
      "CHICHAS": true,
      "CHUQUIBAMBA": true,
      "IRAY": true,
      "RIO GRANDE": true,
      "SALAMANCA": true,
      "YANAQUIHUA": true
    },
    "ISLAY": {
      "COCACHACRA": true,
      "DEAN VALDIVIA": true,
      "ISLAY": true,
      "MEJIA": true,
      "MOLLENDO": true,
      "PUNTA DE BOMBON": true
    },
    "LA UNION": {
      "ALCA": true,
      "CHARCANA": true,
      "COTAHUASI": true,
      "HUAYNACOTAS": true,
      "PAMPAMARCA": true,
      "PUYCA": true,
      "QUECHUALLA": true,
      "SAYLA": true,
      "TAURIA": true,
      "TOMEPAMPA": true,
      "TORO": true
    }
  },
  "AYACUCHO": {
    "CANGALLO": {
      "CANGALLO": true,
      "CHUSCHI": true,
      "LOS MOROCHUCOS": true,
      "MARIA PARADO DE BELLIDO": true,
      "PARAS": true,
      "TOTOS": true
    },
    "HUAMANGA": {
      "ACOCRO": true,
      "ACOS VINCHOS": true,
      "AYACUCHO": true,
      "CARMEN ALTO": true,
      "CHIARA": true,
      "JESUS NAZARENO": true,
      "OCROS": true,
      "PACAYCASA": true,
      "QUINUA": true,
      "SAN JOSE DE TICLLAS": true,
      "SAN JUAN BAUTISTA": true,
      "SANTIAGO DE PISCHA": true,
      "SOCOS": true,
      "TAMBILLO": true,
      "VINCHOS": true
    },
    "HUANCA SANCOS": {
      "CARAPO": true,
      "SACSAMARCA": true,
      "SANCOS": true,
      "SANTIAGO DE LUCANAMARCA": true
    },
    "HUANTA": {
      "AYAHUANCO": true,
      "HUAMANGUILLA": true,
      "HUANTA": true,
      "IGUAIN": true,
      "LLOCHEGUA": true,
      "LURICOCHA": true,
      "SANTILLANA": true,
      "SIVIA": true
    },
    "LA MAR": {
      "ANCO": true,
      "AYNA": true,
      "CHILCAS": true,
      "CHUNGUI": true,
      "LUIS CARRANZA": true,
      "SAMUGARI": true,
      "SAN MIGUEL": true,
      "SANTA ROSA": true,
      "TAMBO": true
    },
    "LUCANAS": {
      "AUCARA": true,
      "CABANA": true,
      "CARMEN SALCEDO": true,
      "CHAVIÑA": true,
      "CHIPAO": true,
      "HUAC-HUAS": true,
      "LARAMATE": true,
      "LEONCIO PRADO": true,
      "LLAUTA": true,
      "LUCANAS": true,
      "OCAÑA": true,
      "OTOCA": true,
      "PUQUIO": true,
      "SAISA": true,
      "SAN CRISTOBAL": true,
      "SAN JUAN": true,
      "SAN PEDRO": true,
      "SAN PEDRO DE PALCO": true,
      "SANCOS": true,
      "SANTA ANA DE HUAYCAHUACHO": true,
      "SANTA LUCIA": true
    },
    "PARINACOCHAS": {
      "CHUMPI": true,
      "CORACORA": true,
      "CORONEL CASTAÑEDA": true,
      "PACAPAUSA": true,
      "PULLO": true,
      "PUYUSCA": true,
      "SAN FRANCISCO DE RAVACAYCO": true,
      "UPAHUACHO": true
    },
    "PAUCAR DEL SARA SARA": {
      "COLTA": true,
      "CORCULLA": true,
      "LAMPA": true,
      "MARCABAMBA": true,
      "OYOLO": true,
      "PARARCA": true,
      "PAUSA": true,
      "SAN JAVIER DE ALPABAMBA": true,
      "SAN JOSE DE USHUA": true,
      "SARA SARA": true
    },
    "SUCRE": {
      "BELEN": true,
      "CHALCOS": true,
      "CHILCAYOC": true,
      "HUACAÑA": true,
      "MORCOLLA": true,
      "PAICO": true,
      "QUEROBAMBA": true,
      "SAN PEDRO DE LARCAY": true,
      "SAN SALVADOR DE QUIJE": true,
      "SANTIAGO DE PAUCARAY": true,
      "SORAS": true
    },
    "VICTOR FAJARDO": {
      "ALCAMENCA": true,
      "APONGO": true,
      "ASQUIPATA": true,
      "CANARIA": true,
      "CAYARA": true,
      "COLCA": true,
      "HUAMANQUIQUIA": true,
      "HUANCAPI": true,
      "HUANCARAYLLA": true,
      "HUAYA": true,
      "SARHUA": true,
      "VILCANCHOS": true
    },
    "VILCAS HUAMAN": {
      "ACCOMARCA": true,
      "CARHUANCA": true,
      "CONCEPCION": true,
      "HUAMBALPA": true,
      "INDEPENDENCIA": true,
      "SAURAMA": true,
      "VILCAS HUAMAN": true,
      "VISCHONGO": true
    }
  },
  "CAJAMARCA": {
    "CAJABAMBA": {
      "CACHACHI": true,
      "CAJABAMBA": true,
      "CONDEBAMBA": true,
      "SITACOCHA": true
    },
    "CAJAMARCA": {
      "ASUNCION": true,
      "CAJAMARCA": true,
      "CHETILLA": true,
      "COSPAN": true,
      "ENCAÑADA": true,
      "JESUS": true,
      "LLACANORA": true,
      "LOS BAÑOS DEL INCA": true,
      "MAGDALENA": true,
      "MATARA": true,
      "NAMORA": true,
      "SAN JUAN": true
    },
    "CELENDIN": {
      "CELENDIN": true,
      "CHUMUCH": true,
      "CORTEGANA": true,
      "HUASMIN": true,
      "JORGE CHAVEZ": true,
      "JOSE GALVEZ": true,
      "LA LIBERTAD DE PALLAN": true,
      "MIGUEL IGLESIAS": true,
      "OXAMARCA": true,
      "SOROCHUCO": true,
      "SUCRE": true,
      "UTCO": true
    },
    "CHOTA": {
      "ANGUIA": true,
      "CHADIN": true,
      "CHALAMARCA": true,
      "CHIGUIRIP": true,
      "CHIMBAN": true,
      "CHOROPAMPA": true,
      "CHOTA": true,
      "COCHABAMBA": true,
      "CONCHAN": true,
      "HUAMBOS": true,
      "LAJAS": true,
      "LLAMA": true,
      "MIRACOSTA": true,
      "PACCHA": true,
      "PION": true,
      "QUEROCOTO": true,
      "SAN JUAN DE LICUPIS": true,
      "TACABAMBA": true,
      "TOCMOCHE": true
    },
    "CONTUMAZA": {
      "CHILETE": true,
      "CONTUMAZA": true,
      "CUPISNIQUE": true,
      "GUZMANGO": true,
      "SAN BENITO": true,
      "SANTA CRUZ DE TOLED": true,
      "TANTARICA": true,
      "YONAN": true
    },
    "CUTERVO": {
      "CALLAYUC": true,
      "CHOROS": true,
      "CUJILLO": true,
      "CUTERVO": true,
      "LA RAMADA": true,
      "PIMPINGOS": true,
      "QUEROCOTILLO": true,
      "SAN ANDRES DE CUTERVO": true,
      "SAN JUAN DE CUTERVO": true,
      "SAN LUIS DE LUCMA": true,
      "SANTA CRUZ": true,
      "SANTO DOMINGO DE LA CAPILLA": true,
      "SANTO TOMAS": true,
      "SOCOTA": true,
      "TORIBIO CASANOVA": true
    },
    "HUALGAYOC": {
      "BAMBAMARCA": true,
      "CHUGUR": true,
      "HUALGAYOC": true
    },
    "JAEN": {
      "BELLAVISTA": true,
      "CHONTALI": true,
      "COLASAY": true,
      "HUABAL": true,
      "JAEN": true,
      "LAS PIRIAS": true,
      "POMAHUACA": true,
      "PUCARA": true,
      "SALLIQUE": true,
      "SAN FELIPE": true,
      "SAN JOSE DEL ALTO": true,
      "SANTA ROSA": true
    },
    "SAN IGNACIO": {
      "CHIRINOS": true,
      "HUARANGO": true,
      "LA COIPA": true,
      "NAMBALLE": true,
      "SAN IGNACIO": true,
      "SAN JOSE DE LOURDES": true,
      "TABACONAS": true
    },
    "SAN MARCOS": {
      "CHANCAY": true,
      "EDUARDO VILLANUEVA": true,
      "GREGORIO PITA": true,
      "ICHOCAN": true,
      "JOSE MANUEL QUIROZ": true,
      "JOSE SABOGAL": true,
      "PEDRO GALVEZ": true
    },
    "SAN MIGUEL": {
      "BOLIVAR": true,
      "CALQUIS": true,
      "CATILLUC": true,
      "EL PRADO": true,
      "LA FLORIDA": true,
      "LLAPA": true,
      "NANCHOC": true,
      "NIEPOS": true,
      "SAN GREGORIO": true,
      "SAN MIGUEL": true,
      "SAN SILVESTRE DE COCHAN": true,
      "TONGOD": true,
      "UNION AGUA BLANCA": true
    },
    "SAN PABLO": {
      "SAN BERNARDINO": true,
      "SAN LUIS": true,
      "SAN PABLO": true,
      "TUMBADEN": true
    },
    "SANTA CRUZ": {
      "ANDABAMBA": true,
      "CATACHE": true,
      "CHANCAYBAÑOS": true,
      "LA ESPERANZA": true,
      "NINABAMBA": true,
      "PULAN": true,
      "SANTA CRUZ": true,
      "SAUCEPAMPA": true,
      "SEXI": true,
      "UTICYACU": true,
      "YAUYUCAN": true
    }
  },
  "CUZCO": {
    "ACOMAYO": {
      "ACOMAYO": true,
      "ACOPIA": true,
      "ACOS": true,
      "MOSOC LLACTA": true,
      "POMACANCHI": true,
      "RONDOCAN": true,
      "SANGARARA": true
    },
    "ANTA": {
      "ANCAHUASI": true,
      "ANTA": true,
      "CACHIMAYO": true,
      "CHINCHAYPUJIO": true,
      "HUAROCONDO": true,
      "LIMATAMBO": true,
      "MOLLEPATA": true,
      "PUCYURA": true,
      "ZURITE": true
    },
    "CALCA": {
      "CALCA": true,
      "COYA": true,
      "LAMAY": true,
      "LARES": true,
      "PISAC": true,
      "SAN SALVADOR": true,
      "TARAY": true,
      "YANATILE": true
    },
    "CANAS": {
      "CHECCA": true,
      "KUNTURKANKI": true,
      "LANGUI": true,
      "LAYO": true,
      "PAMPAMARCA": true,
      "QUEHUE": true,
      "TUPAC AMARU": true,
      "YANAOCA": true
    },
    "CANCHIS": {
      "CHECACUPE": true,
      "COMBAPATA": true,
      "MARANGANI": true,
      "PITUMARCA": true,
      "SAN PABLO": true,
      "SAN PEDRO": true,
      "SICUANI": true,
      "TINTA": true
    },
    "CHUMBIVILCAS": {
      "CAPACMARCA": true,
      "CHAMACA": true,
      "COLQUEMARCA": true,
      "LIVITACA": true,
      "LLUSCO": true,
      "QUIÑOTA": true,
      "SANTO TOMAS": true,
      "VELILLE": true
    },
    "CUSCO": {
      "CCORCA": true,
      "CUSCO": true,
      "POROY": true,
      "SAN JERONIMO": true,
      "SAN SEBASTIAN": true,
      "SANTIAGO": true,
      "SAYLLA": true,
      "WANCHAQ": true
    },
    "ESPINAR": {
      "ALTO PICHIGUA": true,
      "CONDOROMA": true,
      "COPORAQUE": true,
      "ESPINAR": true,
      "OCORURO": true,
      "PALLPATA": true,
      "PICHIGUA": true,
      "SUYCKUTAMBO": true
    },
    "LA CONVENCION": {
      "ECHARATE": true,
      "HUAYOPATA": true,
      "KIMBIRI": true,
      "MARANURA": true,
      "OCOBAMBA": true,
      "PICHARI": true,
      "QUELLOUNO": true,
      "SANTA ANA": true,
      "SANTA TERESA": true,
      "VILCABAMBA": true
    },
    "PARURO": {
      "ACCHA": true,
      "CCAPI": true,
      "COLCHA": true,
      "HUANOQUITE": true,
      "OMACHA": true,
      "PACCARITAMBO": true,
      "PARURO": true,
      "PILLPINTO": true,
      "YAURISQUE": true
    },
    "PAUCARTAMBO": {
      "CAICAY": true,
      "CHALLABAMBA": true,
      "COLQUEPATA": true,
      "HUANCARANI": true,
      "KOSÑIPATA": true,
      "PAUCARTAMBO": true
    },
    "QUISPICANCHI": {
      "ANDAHUAYLILLAS": true,
      "CAMANTI": true,
      "CCARHUAYO": true,
      "CCATCA": true,
      "CUSIPATA": true,
      "HUARO": true,
      "LUCRE": true,
      "MARCAPATA": true,
      "OCONGATE": true,
      "OROPESA": true,
      "QUIQUIJANA": true,
      "URCOS": true
    },
    "URUBAMBA": {
      "CHINCHERO": true,
      "HUAYLLABAMBA": true,
      "MACHUPICCHU": true,
      "MARAS": true,
      "OLLANTAYTAMBO": true,
      "URUBAMBA": true,
      "YUCAY": true
    }
  },
  "HUANCAVELICA": {
    "ACOBAMBA": {
      "ACOBAMBA": true,
      "ANDABAMBA": true,
      "ANTA": true,
      "CAJA": true,
      "MARCAS": true,
      "PAUCARA": true,
      "POMACOCHA": true,
      "ROSARIO": true
    },
    "ANGARAES": {
      "ANCHONGA": true,
      "CALLANMARCA": true,
      "CCOCHACCASA": true,
      "CHINCHO": true,
      "CONGALLA": true,
      "HUANCA-HUANCA": true,
      "HUAYLLAY GRANDE": true,
      "JULCAMARCA": true,
      "LIRCAY": true,
      "SAN ANTONIO DE ANTAPARCO": true,
      "SANTO TOMAS DE PATA": true,
      "SECCLLA": true
    },
    "CASTROVIRREYNA": {
      "ARMA": true,
      "AURAHUA": true,
      "CAPILLAS": true,
      "CASTROVIRREYNA": true,
      "CHUPAMARCA": true,
      "COCAS": true,
      "HUACHOS": true,
      "HUAMATAMBO": true,
      "MOLLEPAMPA": true,
      "SAN JUAN": true,
      "SANTA ANA": true,
      "TANTARA": true,
      "TICRAPO": true
    },
    "CHURCAMPA": {
      "ANCO": true,
      "CHINCHIHUASI": true,
      "CHURCAMPA": true,
      "COSME": true,
      "EL CARMEN": true,
      "LA MERCED": true,
      "LOCROJA": true,
      "PACHAMARCA": true,
      "PAUCARBAMBA": true,
      "SAN MIGUEL DE MAYOCC": true,
      "SAN PEDRO DE CORIS": true
    },
    "HUANCAVELICA": {
      "ACOBAMBILLA": true,
      "ACORIA": true,
      "ASCENSION": true,
      "CONAYCA": true,
      "CUENCA": true,
      "HUACHOCOLPA": true,
      "HUANCAVELICA": true,
      "HUANDO": true,
      "HUAYLLAHUARA": true,
      "IZCUCHACA": true,
      "LARIA": true,
      "MANTA": true,
      "MARISCAL CACERES": true,
      "MOYA": true,
      "NUEVO OCCORO": true,
      "PALCA": true,
      "PILCHACA": true,
      "VILCA": true,
      "YAULI": true
    },
    "HUAYTARA": {
      "AYAVI": true,
      "CORDOVA": true,
      "HUAYACUNDO ARMA": true,
      "HUAYTARA": true,
      "LARAMARCA": true,
      "OCOYO": true,
      "PILPICHACA": true,
      "QUERCO": true,
      "QUITO-ARMA": true,
      "SAN ANTONIO DE CUSICANCHA": true,
      "SAN FRANCISCO DE SANGAYAICO": true,
      "SAN ISIDRO": true,
      "SANTIAGO DE CHOCORVOS": true,
      "SANTIAGO DE QUIRAHUARA": true,
      "SANTO DOMINGO DE CAPILLAS": true,
      "TAMBO": true
    },
    "TAYACAJA": {
      "ACOSTAMBO": true,
      "ACRAQUIA": true,
      "AHUAYCHA": true,
      "COLCABAMBA": true,
      "DANIEL HERNANDEZ": true,
      "HUACHOCOLPA": true,
      "HUANDO": true,
      "HUARIBAMBA": true,
      "ÑAHUIMPUQUIO": true,
      "PAMPAS": true,
      "PAZOS": true,
      "QUISHUAR": true,
      "SALCABAMBA": true,
      "SALCAHUASI": true,
      "SAN MARCOS DE ROCCHAC": true,
      "SURCUBAMBA": true,
      "TINTAY PUNCU": true
    }
  },
  "HUÁNUCO": {
    "AMBO": {
      "AMBO": true,
      "CAYNA": true,
      "COLPAS": true,
      "CONCHAMARCA": true,
      "HUACAR": true,
      "SAN FRANCISCO": true,
      "SAN RAFAEL": true,
      "TOMAY KICHWA": true
    },
    "DOS DE MAYO": {
      "CHUQUIS": true,
      "LA UNION": true,
      "MARIAS": true,
      "PACHAS": true,
      "QUIVILLA": true,
      "RIPAN": true,
      "SHUNQUI": true,
      "SILLAPATA": true,
      "YANAS": true
    },
    "HUACAYBAMBA": {
      "CANCHABAMBA": true,
      "COCHABAMBA": true,
      "HUACAYBAMBA": true,
      "PINRA": true
    },
    "HUAMALIES": {
      "ARANCAY": true,
      "CHAVIN DE PARIARCA": true,
      "JACAS GRANDE": true,
      "JIRCAN": true,
      "LLATA": true,
      "MIRAFLORES": true,
      "MONZON": true,
      "PUNCHAO": true,
      "PUÑOS": true,
      "SINGA": true,
      "TANTAMAYO": true
    },
    "HUANUCO": {
      "AMARILIS": true,
      "CHINCHAO": true,
      "CHURUBAMBA": true,
      "HUANUCO": true,
      "MARGOS": true,
      "PILLCO MARCA": true,
      "QUISQUI": true,
      "SAN FRANCISCO DE CAYRAN": true,
      "SAN PEDRO DE CHAULAN": true,
      "SANTA MARIA DEL VALLE": true,
      "YACUS": true,
      "YARUMAYO": true
    },
    "LAURICOCHA": {
      "BAÑOS": true,
      "JESUS": true,
      "JIVIA": true,
      "QUEROPALCA": true,
      "RONDOS": true,
      "SAN FRANCISCO DE ASIS": true,
      "SAN MIGUEL DE CAURI": true
    },
    "LEONCIO PRADO": {
      "DANIEL ALOMIA ROBLES": true,
      "HERMILIO VALDIZAN": true,
      "JOSE CRESPO Y CASTILLO": true,
      "LUYANDO": true,
      "MARIANO DAMASO BERAUN": true,
      "RUPA-RUPA": true
    },
    "MARAÑON": {
      "CHOLON": true,
      "HUACRACHUCO": true,
      "SAN BUENAVENTURA": true
    },
    "PACHITEA": {
      "CHAGLLA": true,
      "MOLINO": true,
      "PANAO": true,
      "UMARI": true
    },
    "PUERTO INCA": {
      "CODO DEL POZUZO": true,
      "HONORIA": true,
      "PUERTO INCA": true,
      "TOURNAVISTA": true,
      "YUYAPICHIS": true
    },
    "YAROWILCA": {
      "APARICIO POMARES": true,
      "CAHUAC": true,
      "CHACABAMBA": true,
      "CHAVINILLO": true,
      "CHORAS": true,
      "JACAS CHICO": true,
      "OBAS": true,
      "PAMPAMARCA": true
    }
  },
  "ICA": {
    "CHINCHA": {
      "ALTO LARAN": true,
      "CHAVIN": true,
      "CHINCHA ALTA": true,
      "CHINCHA BAJA": true,
      "EL CARMEN": true,
      "GROCIO PRADO": true,
      "PUEBLO NUEVO": true,
      "SAN JUAN DE YANAC": true,
      "SAN PEDRO DE HUACARPANA": true,
      "SUNAMPE": true,
      "TAMBO DE MORA": true
    },
    "ICA": {
      "ICA": true,
      "LA TINGUIÑA": true,
      "LOS AQUIJES": true,
      "OCUCAJE": true,
      "PACHACUTEC": true,
      "PARCONA": true,
      "PUEBLO NUEVO": true,
      "SALAS": true,
      "SAN JOSE DE LOS MOLINOS": true,
      "SAN JUAN BAUTISTA": true,
      "SANTIAGO": true,
      "SUBTANJALLA": true,
      "TATE": true,
      "YAUCA DEL ROSARIO": true
    },
    "NAZCA": {
      "CHANGUILLO": true,
      "EL INGENIO": true,
      "MARCONA": true,
      "NAZCA": true,
      "VISTA ALEGRE": true
    },
    "PALPA": {
      "LLIPATA": true,
      "PALPA": true,
      "RIO GRANDE": true,
      "SANTA CRUZ": true,
      "TIBILLO": true
    },
    "PISCO": {
      "HUANCANO": true,
      "HUAYTARA": true,
      "HUMAY": true,
      "INDEPENDENCIA": true,
      "PARACAS": true,
      "PISCO": true,
      "SAN ANDRES": true,
      "SAN CLEMENTE": true,
      "TUPAC AMARU INCA": true
    }
  },
  "JUNÍN": {
    "CHANCHAMAYO": {
      "CHANCHAMAYO": true,
      "PERENE": true,
      "PICHANAQUI": true,
      "SAN LUIS DE SHUARO": true,
      "SAN RAMON": true,
      "VITOC": true
    },
    "CHUPACA": {
      "AHUAC": true,
      "CHONGOS BAJO": true,
      "CHUPACA": true,
      "HUACHAC": true,
      "HUAMANCACA CHICO": true,
      "SAN JUAN DE ISCOS": true,
      "SAN JUAN DE JARPA": true,
      "TRES DE DICIEMBRE": true,
      "YANACANCHA": true
    },
    "CONCEPCION": {
      "ACO": true,
      "ANDAMARCA": true,
      "CHAMBARA": true,
      "COCHAS": true,
      "COMAS": true,
      "CONCEPCION": true,
      "HEROINAS TOLEDO": true,
      "MANZANARES": true,
      "MARISCAL CASTILLA": true,
      "MATAHUASI": true,
      "MITO": true,
      "NUEVE DE JULIO": true,
      "ORCOTUNA": true,
      "SAN JOSE DE QUERO": true,
      "SANTA ROSA DE OCOPA": true
    },
    "HUANCAYO": {
      "CARHUACALLANGA": true,
      "CHACAPAMPA": true,
      "CHICCHE": true,
      "CHILCA": true,
      "CHONGOS ALTO": true,
      "CHUPURO": true,
      "COLCA": true,
      "CULLHUAS": true,
      "EL TAMBO": true,
      "HUACRAPUQUIO": true,
      "HUALHUAS": true,
      "HUANCAN": true,
      "HUANCAYO": true,
      "HUASICANCHA": true,
      "HUAYUCACHI": true,
      "INGENIO": true,
      "PARIAHUANCA": true,
      "PILCOMAYO": true,
      "PUCARA": true,
      "QUICHUAY": true,
      "QUILCAS": true,
      "SAN AGUSTIN": true,
      "SAN JERONIMO DE TUNAN": true,
      "SANTO DOMINGO DE ACOBAMBA": true,
      "SAÑO": true,
      "SAPALLANGA": true,
      "SICAYA": true,
      "VIQUES": true
    },
    "JAUJA": {
      "ACOLLA": true,
      "APATA": true,
      "ATAURA": true,
      "CANCHAYLLO": true,
      "CURICACA": true,
      "EL MANTARO": true,
      "HUAMALI": true,
      "HUARIPAMPA": true,
      "HUERTAS": true,
      "JANJAILLO": true,
      "JAUJA": true,
      "JULCAN": true,
      "LEONOR ORDOÑEZ": true,
      "LLOCLLAPAMPA": true,
      "MARCO": true,
      "MASMA": true,
      "MASMA CHICCHE": true,
      "MOLINOS": true,
      "MONOBAMBA": true,
      "MUQUI": true,
      "MUQUIYAUYO": true,
      "PACA": true,
      "PACCHA": true,
      "PANCAN": true,
      "PARCO": true,
      "POMACANCHA": true,
      "RICRAN": true,
      "SAN LORENZO": true,
      "SAN PEDRO DE CHUNAN": true,
      "SAUSA": true,
      "SINCOS": true,
      "TUNAN MARCA": true,
      "YAULI": true,
      "YAUYOS": true
    },
    "JUNIN": {
      "CARHUAMAYO": true,
      "JUNIN": true,
      "ONDORES": true,
      "ULCUMAYO": true
    },
    "SATIPO": {
      "COVIRIALI": true,
      "LLAYLLA": true,
      "MAZAMARI": true,
      "PAMPA HERMOSA": true,
      "PANGOA": true,
      "RIO NEGRO": true,
      "RIO TAMBO": true,
      "SATIPO": true
    },
    "TARMA": {
      "ACOBAMBA": true,
      "HUARICOLCA": true,
      "HUASAHUASI": true,
      "LA UNION": true,
      "PALCA": true,
      "PALCAMAYO": true,
      "SAN PEDRO DE CAJAS": true,
      "TAPO": true,
      "TARMA": true
    },
    "YAULI": {
      "CHACAPALPA": true,
      "HUAY-HUAY": true,
      "LA OROYA": true,
      "MARCAPOMACOCHA": true,
      "MOROCOCHA": true,
      "PACCHA": true,
      "SANTA BARBARA DE CARHUACAYAN": true,
      "SANTA ROSA DE SACCO": true,
      "SUITUCANCHA": true,
      "YAULI": true
    }
  },
  "LA LIBERTAD": {
    "ASCOPE": {
      "ASCOPE": true,
      "CASA GRANDE": true,
      "CHICAMA": true,
      "CHOCOPE": true,
      "MAGDALENA DE CAO": true,
      "PAIJAN": true,
      "RAZURI": true,
      "SANTIAGO DE CAO": true
    },
    "BOLIVAR": {
      "BAMBAMARCA": true,
      "BOLIVAR": true,
      "CONDORMARCA": true,
      "LONGOTEA": true,
      "UCHUMARCA": true,
      "UCUNCHA": true
    },
    "CHEPEN": {
      "CHEPEN": true,
      "PACANGA": true,
      "PUEBLO NUEVO": true
    },
    "GRAN CHIMU": {
      "CASCAS": true,
      "LUCMA": true,
      "MARMOT": true,
      "SAYAPULLO": true
    },
    "JULCAN": {
      "CALAMARCA": true,
      "CARABAMBA": true,
      "HUASO": true,
      "JULCAN": true
    },
    "OTUZCO": {
      "AGALLPAMPA": true,
      "CHARAT": true,
      "HUARANCHAL": true,
      "LA CUESTA": true,
      "MACHE": true,
      "OTUZCO": true,
      "PARANDAY": true,
      "SALPO": true,
      "SINSICAP": true,
      "USQUIL": true
    },
    "PACASMAYO": {
      "GUADALUPE": true,
      "JEQUETEPEQUE": true,
      "PACASMAYO": true,
      "SAN JOSE": true,
      "SAN PEDRO DE LLOC": true
    },
    "PATAZ": {
      "BULDIBUYO": true,
      "CHILLIA": true,
      "HUANCASPATA": true,
      "HUAYLILLAS": true,
      "HUAYO": true,
      "ONGON": true,
      "PARCOY": true,
      "PATAZ": true,
      "PIAS": true,
      "SANTIAGO DE CHALLAS": true,
      "TAURIJA": true,
      "TAYABAMBA": true,
      "URPAY": true
    },
    "SANCHEZ CARRION": {
      "CHUGAY": true,
      "COCHORCO": true,
      "CURGOS": true,
      "HUAMACHUCO": true,
      "MARCABAL": true,
      "SANAGORAN": true,
      "SARIN": true,
      "SARTIMBAMBA": true
    },
    "SANTIAGO DE CHUCO": {
      "ANGASMARCA": true,
      "CACHICADAN": true,
      "MOLLEBAMBA": true,
      "MOLLEPATA": true,
      "QUIRUVILCA": true,
      "SANTA CRUZ DE CHUCA": true,
      "SANTIAGO DE CHUCO": true,
      "SITABAMBA": true
    },
    "TRUJILLO": {
      "BUENOS AIRES": true,
      "EL PORVENIR": true,
      "FLORENCIA DE MORA": true,
      "HUANCHACO": true,
      "LA ESPERANZA": true,
      "LAREDO": true,
      "MOCHE": true,
      "POROTO": true,
      "SALAVERRY": true,
      "SIMBAL": true,
      "TRUJILLO": true,
      "VICTOR LARCO HERRERA": true
    },
    "VIRU": {
      "CHAO": true,
      "GUADALUPITO": true,
      "VIRU": true
    }
  },
  "LAMBAYEQUE": {
    "CHICLAYO": {
      "CAYALTI": true,
      "CHICLAYO": true,
      "CHONGOYAPE": true,
      "ETEN": true,
      "ETEN PUERTO": true,
      "JOSE LEONARDO ORTIZ": true,
      "LA VICTORIA": true,
      "LAGUNAS": true,
      "MONSEFU": true,
      "NUEVA ARICA": true,
      "OYOTUN": true,
      "PATAPO": true,
      "PICSI": true,
      "PIMENTEL": true,
      "POMALCA": true,
      "PUCALA": true,
      "REQUE": true,
      "SANTA ROSA": true,
      "TUMAN": true,
      "ZAÑA": true
    },
    "FERREÑAFE": {
      "CAÑARIS": true,
      "FERREÑAFE": true,
      "INCAHUASI": true,
      "MANUEL ANTONIO MESONES MURO": true,
      "PITIPO": true,
      "PUEBLO NUEVO": true
    },
    "LAMBAYEQUE": {
      "CHOCHOPE": true,
      "ILLIMO": true,
      "JAYANCA": true,
      "LAMBAYEQUE": true,
      "MOCHUMI": true,
      "MORROPE": true,
      "MOTUPE": true,
      "OLMOS": true,
      "PACORA": true,
      "SALAS": true,
      "SAN JOSE": true,
      "TUCUME": true
    }
  },
  "LIMA": {
    "BARRANCA": {
      "BARRANCA": true,
      "PARAMONGA": true,
      "PATIVILCA": true,
      "SUPE": true,
      "SUPE PUERTO": true
    },
    "CAJATAMBO": {
      "CAJATAMBO": true,
      "COPA": true,
      "GORGOR": true,
      "HUANCAPON": true,
      "MANAS": true
    },
    "CANTA": {
      "ARAHUAY": true,
      "CANTA": true,
      "HUAMANTANGA": true,
      "HUAROS": true,
      "LACHAQUI": true,
      "SAN BUENAVENTURA": true,
      "SANTA ROSA DE QUIVES": true
    },
    "CAÑETE": {
      "ASIA": true,
      "CALANGO": true,
      "CERRO AZUL": true,
      "CHILCA": true,
      "COAYLLO": true,
      "IMPERIAL": true,
      "LUNAHUANA": true,
      "MALA": true,
      "NUEVO IMPERIAL": true,
      "PACARAN": true,
      "QUILMANA": true,
      "SAN ANTONIO": true,
      "SAN LUIS": true,
      "SAN VICENTE DE CAÑETE": true,
      "SANTA CRUZ DE FLORES": true,
      "ZUÑIGA": true
    },
    "HUARAL": {
      "ATAVILLOS ALTO": true,
      "ATAVILLOS BAJO": true,
      "AUCALLAMA": true,
      "CHANCAY": true,
      "HUARAL": true,
      "IHUARI": true,
      "LAMPIAN": true,
      "PACARAOS": true,
      "SAN MIGUEL DE ACOS": true,
      "SANTA CRUZ DE ANDAMARCA": true,
      "SUMBILCA": true,
      "VEINTISIETE DE NOVIEMBRE": true
    },
    "HUAROCHIRI": {
      "ANTIOQUIA": true,
      "CALLAHUANCA": true,
      "CARAMPOMA": true,
      "CHICLA": true,
      "CUENCA": true,
      "HUACHUPAMPA": true,
      "HUANZA": true,
      "HUAROCHIRI": true,
      "LAHUAYTAMBO": true,
      "LANGA": true,
      "LARAOS": true,
      "MARIATANA": true,
      "MATUCANA": true,
      "RICARDO PALMA": true,
      "SAN ANDRES DE TUPICOCHA": true,
      "SAN ANTONIO": true,
      "SAN BARTOLOME": true,
      "SAN DAMIAN": true,
      "SAN JUAN DE IRIS": true,
      "SAN JUAN DE TANTARANCHE": true,
      "SAN LORENZO DE QUINTI": true,
      "SAN MATEO": true,
      "SAN MATEO DE OTAO": true,
      "SAN PEDRO DE CASTA": true,
      "SAN PEDRO DE HUANCAYRE": true,
      "SANGALLAYA": true,
      "SANTA CRUZ DE COCACHACRA": true,
      "SANTA EULALIA": true,
      "SANTIAGO DE ANCHUCAYA": true,
      "SANTIAGO DE TUNA": true,
      "SANTO DOMINGO DE LOS OLLEROS": true,
      "SURCO": true
    },
    "HUAURA": {
      "AMBAR": true,
      "CALETA DE CARQUIN": true,
      "CHECRAS": true,
      "HUACHO": true,
      "HUALMAY": true,
      "HUAURA": true,
      "LEONCIO PRADO": true,
      "PACCHO": true,
      "SANTA LEONOR": true,
      "SANTA MARIA": true,
      "SAYAN": true,
      "VEGUETA": true
    },
    "LIMA": {
      "ANCON": true,
      "ATE": true,
      "BARRANCO": true,
      "BREÑA": true,
      "CARABAYLLO": true,
      "CHACLACAYO": true,
      "CHORRILLOS": true,
      "CIENEGUILLA": true,
      "COMAS": true,
      "EL AGUSTINO": true,
      "INDEPENDENCIA": true,
      "JESUS MARIA": true,
      "LA MOLINA": true,
      "LA VICTORIA": true,
      "CERCADO DE LIMA": true,
      "LINCE": true,
      "LOS OLIVOS": true,
      "LURIGANCHO CHOSICA": true,
      "LURIN": true,
      "MAGDALENA DEL MAR": true,
      "MIRAFLORES": true,
      "PACHACAMAC": true,
      "PUCUSANA": true,
      "PUEBLO LIBRE": true,
      "PUENTE PIEDRA": true,
      "PUNTA HERMOSA": true,
      "PUNTA NEGRA": true,
      "RIMAC": true,
      "SAN BARTOLO": true,
      "SAN BORJA": true,
      "SAN ISIDRO": true,
      "SAN JUAN DE LURIGANCHO": true,
      "SAN JUAN DE MIRAFLORES": true,
      "SAN LUIS": true,
      "SAN MARTIN DE PORRES": true,
      "SAN MIGUEL": true,
      "SANTA ANITA": true,
      "SANTA MARIA DEL MAR": true,
      "SANTA ROSA": true,
      "SANTIAGO DE SURCO": true,
      "SURQUILLO": true,
      "VILLA EL SALVADOR": true,
      "VILLA MARIA DEL TRIUNFO": true
    },
    "OYON": {
      "ANDAJES": true,
      "CAUJUL": true,
      "COCHAMARCA": true,
      "NAVAN": true,
      "OYON": true,
      "PACHANGARA": true
    },
    "YAUYOS": {
      "ALIS": true,
      "AYAUCA": true,
      "AYAVIRI": true,
      "AZANGARO": true,
      "CACRA": true,
      "CARANIA": true,
      "CATAHUASI": true,
      "CHOCOS": true,
      "COCHAS": true,
      "COLONIA": true,
      "HONGOS": true,
      "HUAMPARA": true,
      "HUANCAYA": true,
      "HUANGASCAR": true,
      "HUANTAN": true,
      "HUAÑEC": true,
      "LARAOS": true,
      "LINCHA": true,
      "MADEAN": true,
      "MIRAFLORES": true,
      "OMAS": true,
      "PUTINZA": true,
      "QUINCHES": true,
      "QUINOCAY": true,
      "SAN JOAQUIN": true,
      "SAN PEDRO DE PILAS": true,
      "TANTA": true,
      "TAURIPAMPA": true,
      "TOMAS": true,
      "TUPE": true,
      "VIÑAC": true,
      "VITIS": true,
      "YAUYOS": true
    }
  },
  "CALLAO": {
    "CALLAO": {
      "BELLAVISTA": true,
      "CALLAO": true,
      "CARMEN DE LA LEGUA REYNOSO": true,
      "LA PERLA": true,
      "LA PUNTA": true,
      "MI PERU": true,
      "VENTANILLA": true
    }
  },
  "LORETO": {
    "ALTO AMAZONAS": {
      "BALSAPUERTO": true,
      "JEBEROS": true,
      "LAGUNAS": true,
      "SANTA CRUZ": true,
      "TENIENTE CESAR LOPEZ ROJAS": true,
      "YURIMAGUAS": true
    },
    "DATEM DEL MARAÑON": {
      "ANDOAS": true,
      "BARRANCA": true,
      "CAHUAPANAS": true,
      "MANSERICHE": true,
      "MORONA": true,
      "PASTAZA": true
    },
    "LORETO": {
      "NAUTA": true,
      "PARINARI": true,
      "TIGRE": true,
      "TROMPETEROS": true,
      "URARINAS": true
    },
    "MARISCAL RAMON CASTILLA": {
      "PEBAS": true,
      "RAMON CASTILLA": true,
      "SAN PABLO": true,
      "YAVARI": true
    },
    "MAYNAS": {
      "ALTO NANAY": true,
      "BELEN": true,
      "FERNANDO LORES": true,
      "INDIANA": true,
      "IQUITOS": true,
      "LAS AMAZONAS": true,
      "MAZAN": true,
      "NAPO": true,
      "PUNCHANA": true,
      "PUTUMAYO": true,
      "SAN JUAN BAUTISTA": true,
      "TENIENTE MANUEL CLAVERO": true,
      "TORRES CAUSANA": true
    },
    "REQUENA": {
      "ALTO TAPICHE": true,
      "CAPELO": true,
      "EMILIO SAN MARTIN": true,
      "JENARO HERRERA": true,
      "MAQUIA": true,
      "PUINAHUA": true,
      "REQUENA": true,
      "SAQUENA": true,
      "SOPLIN": true,
      "TAPICHE": true,
      "YAQUERANA": true
    },
    "UCAYALI": {
      "CONTAMANA": true,
      "INAHUAYA": true,
      "PADRE MARQUEZ": true,
      "PAMPA HERMOSA": true,
      "VARGAS GUERRA": true
    }
  },
  "MADRE DE DIOS": {
    "MANU": {
      "FITZCARRALD": true,
      "HUEPETUHE": true,
      "MADRE DE DIOS": true,
      "MANU": true
    },
    "TAHUAMANU": {
      "IBERIA": true,
      "IÑAPARI": true,
      "TAHUAMANU": true
    },
    "TAMBOPATA": {
      "INAMBARI": true,
      "LABERINTO": true,
      "LAS PIEDRAS": true,
      "TAMBOPATA": true
    }
  },
  "MOQUEGUA": {
    "GENERAL SANCHEZ CERRO": {
      "CHOJATA": true,
      "COALAQUE": true,
      "ICHUÑA": true,
      "LA CAPILLA": true,
      "LLOQUE": true,
      "MATALAQUE": true,
      "OMATE": true,
      "PUQUINA": true,
      "QUINISTAQUILLAS": true,
      "UBINAS": true,
      "YUNGA": true
    },
    "ILO": {
      "EL ALGARROBAL": true,
      "ILO": true,
      "PACOCHA": true
    },
    "MARISCAL NIETO": {
      "CARUMAS": true,
      "CUCHUMBAYA": true,
      "MOQUEGUA": true,
      "SAMEGUA": true,
      "SAN CRISTOBAL": true,
      "TORATA": true
    }
  },
  "PASCO": {
    "DANIEL ALCIDES CARRION": {
      "CHACAYAN": true,
      "GOYLLARISQUIZGA": true,
      "PAUCAR": true,
      "SAN PEDRO DE PILLAO": true,
      "SANTA ANA DE TUSI": true,
      "TAPUC": true,
      "VILCABAMBA": true,
      "YANAHUANCA": true
    },
    "OXAPAMPA": {
      "CHONTABAMBA": true,
      "CONSTITUCION": true,
      "HUANCABAMBA": true,
      "OXAPAMPA": true,
      "PALCAZU": true,
      "POZUZO": true,
      "PUERTO BERMUDEZ": true,
      "VILLA RICA": true
    },
    "PASCO": {
      "CHAUPIMARCA": true,
      "HUACHON": true,
      "HUARIACA": true,
      "HUAYLLAY": true,
      "NINACACA": true,
      "PALLANCHACRA": true,
      "PAUCARTAMBO": true,
      "SAN FRANCISCO DE ASIS DE YARUSYACAN": true,
      "SIMON BOLIVAR": true,
      "TICLACAYAN": true,
      "TINYAHUARCO": true,
      "VICCO": true,
      "YANACANCHA": true
    }
  },
  "PIURA": {
    "AYABACA": {
      "AYABACA": true,
      "FRIAS": true,
      "JILILI": true,
      "LAGUNAS": true,
      "MONTERO": true,
      "PACAIPAMPA": true,
      "PAIMAS": true,
      "SAPILLICA": true,
      "SICCHEZ": true,
      "SUYO": true
    },
    "HUANCABAMBA": {
      "CANCHAQUE": true,
      "EL CARMEN DE LA FRONTERA": true,
      "HUANCABAMBA": true,
      "HUARMACA": true,
      "LALAQUIZ": true,
      "SAN MIGUEL DE EL FAIQUE": true,
      "SONDOR": true,
      "SONDORILLO": true
    },
    "MORROPON": {
      "BUENOS AIRES": true,
      "CHALACO": true,
      "CHULUCANAS": true,
      "LA MATANZA": true,
      "MORROPON": true,
      "SALITRAL": true,
      "SAN JUAN DE BIGOTE": true,
      "SANTA CATALINA DE MOSSA": true,
      "SANTO DOMINGO": true,
      "YAMANGO": true
    },
    "PAITA": {
      "AMOTAPE": true,
      "ARENAL": true,
      "COLAN": true,
      "LA HUACA": true,
      "PAITA": true,
      "TAMARINDO": true,
      "VICHAYAL": true
    },
    "PIURA": {
      "CASTILLA": true,
      "CATACAOS": true,
      "CURA MORI": true,
      "EL TALLAN": true,
      "LA ARENA": true,
      "LA UNION": true,
      "LAS LOMAS": true,
      "PIURA": true,
      "TAMBO GRANDE": true,
      "VEINTISEIS DE OCTUBRE": true
    },
    "SECHURA": {
      "BELLAVISTA DE LA UNION": true,
      "BERNAL": true,
      "CRISTO NOS VALGA": true,
      "RINCONADA LLICUAR": true,
      "SECHURA": true,
      "VICE": true
    },
    "SULLANA": {
      "BELLAVISTA": true,
      "IGNACIO ESCUDERO": true,
      "LANCONES": true,
      "MARCAVELICA": true,
      "MIGUEL CHECA": true,
      "QUERECOTILLO": true,
      "SALITRAL": true,
      "SULLANA": true
    },
    "TALARA": {
      "EL ALTO": true,
      "LA BREA": true,
      "LOBITOS": true,
      "LOS ORGANOS": true,
      "MANCORA": true,
      "PARIÑAS": true
    }
  },
  "PUNO": {
    "AZANGARO": {
      "ACHAYA": true,
      "ARAPA": true,
      "ASILLO": true,
      "AZANGARO": true,
      "CAMINACA": true,
      "CHUPA": true,
      "JOSE DOMINGO CHOQUEHUANCA": true,
      "MUÑANI": true,
      "POTONI": true,
      "SAMAN": true,
      "SAN ANTON": true,
      "SAN JOSE": true,
      "SAN JUAN DE SALINAS": true,
      "SANTIAGO DE PUPUJA": true,
      "TIRAPATA": true
    },
    "CARABAYA": {
      "AJOYANI": true,
      "AYAPATA": true,
      "COASA": true,
      "CORANI": true,
      "CRUCERO": true,
      "ITUATA": true,
      "MACUSANI": true,
      "OLLACHEA": true,
      "SAN GABAN": true,
      "USICAYOS": true
    },
    "CHUCUITO": {
      "DESAGUADERO": true,
      "HUACULLANI": true,
      "JULI": true,
      "KELLUYO": true,
      "PISACOMA": true,
      "POMATA": true,
      "ZEPITA": true
    },
    "EL COLLAO": {
      "CAPAZO": true,
      "CONDURIRI": true,
      "ILAVE": true,
      "PILCUYO": true,
      "SANTA ROSA": true
    },
    "HUANCANE": {
      "COJATA": true,
      "HUANCANE": true,
      "HUATASANI": true,
      "INCHUPALLA": true,
      "PUSI": true,
      "ROSASPATA": true,
      "TARACO": true,
      "VILQUE CHICO": true
    },
    "LAMPA": {
      "CABANILLA": true,
      "CALAPUJA": true,
      "LAMPA": true,
      "NICASIO": true,
      "OCUVIRI": true,
      "PALCA": true,
      "PARATIA": true,
      "PUCARA": true,
      "SANTA LUCIA": true,
      "VILAVILA": true
    },
    "MELGAR": {
      "ANTAUTA": true,
      "AYAVIRI": true,
      "CUPI": true,
      "LLALLI": true,
      "MACARI": true,
      "NUÑOA": true,
      "ORURILLO": true,
      "SANTA ROSA": true,
      "UMACHIRI": true
    },
    "MOHO": {
      "CONIMA": true,
      "HUAYRAPATA": true,
      "MOHO": true,
      "TILALI": true
    },
    "PUNO": {
      "ACORA": true,
      "AMANTANI": true,
      "ATUNCOLLA": true,
      "CAPACHICA": true,
      "CHUCUITO": true,
      "COATA": true,
      "HUATA": true,
      "MAÑAZO": true,
      "PAUCARCOLLA": true,
      "PICHACANI": true,
      "PLATERIA": true,
      "PUNO": true,
      "SAN ANTONIO": true,
      "TIQUILLACA": true,
      "VILQUE": true
    },
    "SAN ANTONIO DE PUTINA": {
      "ANANEA": true,
      "PEDRO VILCA APAZA": true,
      "PUTINA": true,
      "QUILCAPUNCU": true,
      "SINA": true
    },
    "SAN ROMAN": {
      "CABANA": true,
      "CABANILLAS": true,
      "CARACOTO": true,
      "JULIACA": true,
      "SAN MIGUEL": true
    },
    "SANDIA": {
      "ALTO INAMBARI": true,
      "CUYOCUYO": true,
      "LIMBANI": true,
      "PATAMBUCO": true,
      "PHARA": true,
      "QUIACA": true,
      "SAN JUAN DEL ORO": true,
      "SAN PEDRO DE PUTINA PUNCO": true,
      "SANDIA": true,
      "YANAHUAYA": true
    },
    "YUNGUYO": {
      "ANAPIA": true,
      "COPANI": true,
      "CUTURAPI": true,
      "OLLARAYA": true,
      "TINICACHI": true,
      "UNICACHI": true,
      "YUNGUYO": true
    }
  },
  "SAN MARTÍN": {
    "BELLAVISTA": {
      "ALTO BIAVO": true,
      "BAJO BIAVO": true,
      "BELLAVISTA": true,
      "HUALLAGA": true,
      "SAN PABLO": true,
      "SAN RAFAEL": true
    },
    "EL DORADO": {
      "AGUA BLANCA": true,
      "SAN JOSE DE SISA": true,
      "SAN MARTIN": true,
      "SANTA ROSA": true,
      "SHATOJA": true
    },
    "HUALLAGA": {
      "ALTO SAPOSOA": true,
      "EL ESLABON": true,
      "PISCOYACU": true,
      "SACANCHE": true,
      "SAPOSOA": true,
      "TINGO DE SAPOSOA": true
    },
    "LAMAS": {
      "ALONSO DE ALVARADO": true,
      "BARRANQUITA": true,
      "CAYNARACHI": true,
      "CUÑUMBUQUI": true,
      "LAMAS": true,
      "PINTO RECODO": true,
      "RUMISAPA": true,
      "SAN ROQUE DE CUMBAZA": true,
      "SHANAO": true,
      "TABALOSOS": true,
      "ZAPATERO": true
    },
    "MARISCAL CACERES": {
      "CAMPANILLA": true,
      "HUICUNGO": true,
      "JUANJUI": true,
      "PACHIZA": true,
      "PAJARILLO": true
    },
    "MOYOBAMBA": {
      "CALZADA": true,
      "HABANA": true,
      "JEPELACIO": true,
      "MOYOBAMBA": true,
      "SORITOR": true,
      "YANTALO": true
    },
    "PICOTA": {
      "BUENOS AIRES": true,
      "CASPISAPA": true,
      "PICOTA": true,
      "PILLUANA": true,
      "PUCACACA": true,
      "SAN CRISTOBAL": true,
      "SAN HILARION": true,
      "SHAMBOYACU": true,
      "TINGO DE PONASA": true,
      "TRES UNIDOS": true
    },
    "RIOJA": {
      "AWAJUN": true,
      "ELIAS SOPLIN VARGAS": true,
      "NUEVA CAJAMARCA": true,
      "PARDO MIGUEL": true,
      "POSIC": true,
      "RIOJA": true,
      "SAN FERNANDO": true,
      "YORONGOS": true,
      "YURACYACU": true
    },
    "SAN MARTIN": {
      "ALBERTO LEVEAU": true,
      "CACATACHI": true,
      "CHAZUTA": true,
      "CHIPURANA": true,
      "EL PORVENIR": true,
      "HUIMBAYOC": true,
      "JUAN GUERRA": true,
      "LA BANDA DE SHILCAYO": true,
      "MORALES": true,
      "PAPAPLAYA": true,
      "SAN ANTONIO": true,
      "SAUCE": true,
      "SHAPAJA": true,
      "TARAPOTO": true
    },
    "TOCACHE": {
      "NUEVO PROGRESO": true,
      "POLVORA": true,
      "SHUNTE": true,
      "TOCACHE": true,
      "UCHIZA": true
    }
  },
  "TACNA": {
    "CANDARAVE": {
      "CAIRANI": true,
      "CAMILACA": true,
      "CANDARAVE": true,
      "CURIBAYA": true,
      "HUANUARA": true,
      "QUILAHUANI": true
    },
    "JORGE BASADRE": {
      "ILABAYA": true,
      "ITE": true,
      "LOCUMBA": true,
      "TOQUEPALA": true
    },
    "TACNA": {
      "ALTO DE LA ALIANZA": true,
      "CALANA": true,
      "CIUDAD NUEVA": true,
      "CIUDAD NUEVA 2": true,
      "CORONEL GREGORIO ALBARRACIN LANCHIPA": true,
      "INCLAN": true,
      "PACHIA": true,
      "PALCA": true,
      "POCOLLAY": true,
      "SAMA": true,
      "TACNA": true
    },
    "TARATA": {
      "CHUCATAMANI": true,
      "ESTIQUE": true,
      "ESTIQUE-PAMPA": true,
      "SITAJARA": true,
      "SUSAPAYA": true,
      "TARATA": true,
      "TARUCACHI": true,
      "TICACO": true
    }
  },
  "TUMBES": {
    "CONTRALMIRANTE VILLAR": {
      "CANOAS DE PUNTA SAL": true,
      "CASITAS": true,
      "ZORRITOS": true
    },
    "TUMBES": {
      "CORRALES": true,
      "LA CRUZ": true,
      "PAMPAS DE HOSPITAL": true,
      "SAN JACINTO": true,
      "SAN JUAN DE LA VIRGEN": true,
      "TUMBES": true
    },
    "ZARUMILLA": {
      "AGUAS VERDES": true,
      "MATAPALO": true,
      "PAPAYAL": true,
      "ZARUMILLA": true
    }
  },
  "UCAYALI": {
    "ATALAYA": {
      "RAYMONDI": true,
      "SEPAHUA": true,
      "TAHUANIA": true,
      "YURUA": true
    },
    "CORONEL PORTILLO": {
      "CALLERIA": true,
      "CAMPOVERDE": true,
      "IPARIA": true,
      "MANANTAY": true,
      "MASISEA": true,
      "NUEVA REQUENA": true,
      "YARINACOCHA": true,
      "PUCALLPA": true
    },
    "PADRE ABAD": {
      "CURIMANA": true,
      "IRAZOLA": true,
      "PADRE ABAD": true
    },
    "PURUS": {
      "PURUS": true
    }
  }
};


(function () {
  function findTrimmedKey(obj, wanted) {
    const w = String(wanted ?? '').trim();
    return Object.keys(obj || {}).find(k => String(k).trim() === w) || null;
  }

  function transformInputToSelect(inputElement, placeholder) {
    if (!inputElement) return null;

    if (inputElement.tagName === "SELECT") {
      if (!inputElement.querySelector("option[value='']")) {
        const placeholderOption = document.createElement("option");
        placeholderOption.value = "";
        placeholderOption.className = "rsi-select-placeholder";
        placeholderOption.textContent = placeholder || "Seleccione";
        inputElement.insertBefore(placeholderOption, inputElement.firstChild);
      }
      inputElement.classList.add("rsi-select-field");
      return inputElement;
    }

    const select = document.createElement("select");

    select.id = inputElement.id || "";
    select.name = inputElement.name || "";

    select.className = "sc-gSifMm jtIFEn rsi-select-field";

    select.style.cssText = `
      width: 100%;
      height: 32px;
      padding: 0px 25px;
      border: none;
      font-size: 16px;
      color: rgb(0, 0, 0);
      background-color: rgba(169, 181, 211, 0.09);
      box-shadow: none;
      outline: none;
      background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E);
      background-repeat: no-repeat;
      background-position: right 0.7em top 50%;
      background-size: 0.65em;
      appearance: none;
      margin: 0px !important;
      border-radius: 0px 9px 9px 0px !important;
    `;

    ["autocomplete", "required", "data-maxl", "data-minl"].forEach(attr => {
      if (inputElement.hasAttribute(attr)) {
        select.setAttribute(attr, inputElement.getAttribute(attr));
      }
    });

    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "Seleccione";
    select.appendChild(placeholderOption);

    inputElement.replaceWith(select);

    return select;
  }

  function populateDropdown(selectElement, options, placeholder) {
    if (!selectElement) return;

    function normalizeOptions(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) {
        if (!raw.length) return [];
        if (typeof raw[0] === "object") {
          return raw.map(o => {
            const v = o?.value != null ? String(o.value) : String(o?.label ?? "");
            const l = o?.label != null ? String(o.label) : v;
            return { value: v, label: l.trim() };
          });
        }
        return raw.map(s => {
          const txt = String(s);
          return { value: txt, label: txt.trim() };
        });
      }
      if (typeof raw === "object") {
        return Object.keys(raw).map(k => {
          const v = String(k);
          return { value: v, label: v.trim() };
        });
      }
      const asTxt = String(raw);
      return [{ value: asTxt, label: asTxt.trim() }];
    }

    selectElement.innerHTML = "";
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "";
    selectElement.appendChild(placeholderOption);

    let list = [];
    try {
      list = normalizeOptions(options);
    } catch (e) {
      console.error("[populateDropdown] error normalizando opciones:", e, options);
      list = [];
    }

    for (const item of list) {
      if (!item || item.value == null) continue;
      const option = document.createElement("option");
      option.value = String(item.value);                   
      option.textContent = String(item.label ?? item.value).trim(); 
      option.className = "rsi-select-option";
      selectElement.appendChild(option);
    }

    if (list.length === 1) {
      selectElement.value = list[0].value;
      selectElement.dispatchEvent(new Event("change"));
    }
  }

  function initializeDropdowns() {
    const provinceInput     = document.querySelector("#province_country_field, #province");
    const cityInput         = document.querySelector("#city");
    const municipalityInput = document.querySelector("#civic_number");

    if (!provinceInput || !cityInput || !municipalityInput) {
      console.error("Faltan campos requeridos:", {
        province: !!provinceInput, city: !!cityInput, civic: !!municipalityInput
      });
      return;
    }

    const provinceSelect     = transformInputToSelect(provinceInput, "Provincia");
    const citySelect         = transformInputToSelect(cityInput, "Cantón");
    const municipalitySelect = transformInputToSelect(municipalityInput, "Distrito");

    citySelect.disabled = true;
    municipalitySelect.disabled = true;

    populateDropdown(provinceSelect, (typeof data === "object") ? data : {}, "Provincia");

    provinceSelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const provKey = findTrimmedKey(data, selProv);

      if (provKey && data[provKey]) {
        populateDropdown(citySelect, data[provKey], "Cantón");
        citySelect.disabled = false;

        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        municipalitySelect.disabled = true;

        const cityKeys = Object.keys(data[provKey] || {});
        if (cityKeys.length === 1) {
          citySelect.value = cityKeys[0];
          citySelect.dispatchEvent(new Event("change"));
        }
      } else {
        citySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Cantón</option>';
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        citySelect.disabled = true;
        municipalitySelect.disabled = true;
      }
    });

    citySelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const selCity = citySelect.value;

      const provKey = findTrimmedKey(data, selProv);
      const cityKey = provKey ? findTrimmedKey(data[provKey], selCity) : null;

      if (provKey && cityKey && data[provKey][cityKey]) {
        populateDropdown(
          municipalitySelect,
          data[provKey][cityKey],   
          "Distrito"
        );
        municipalitySelect.disabled = false;

        const muniKeys = Object.keys(data[provKey][cityKey] || {});
        if (muniKeys.length === 1) {
          municipalitySelect.value = muniKeys[0];
          municipalitySelect.dispatchEvent(new Event("change"));
        }
      } else {
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Distrito</option>';
        municipalitySelect.disabled = true;
      }
    });
  }

  const PROV_SELECTOR = "#province_country_field, #province";
  let formWasOpen = false;

  function tryInit() {
    const provinceField = document.querySelector(PROV_SELECTOR);
    if (provinceField && !formWasOpen) {
      formWasOpen = true;
      initializeDropdowns();
    }
    if (!provinceField && formWasOpen) {
      formWasOpen = false;
    }
  }

  tryInit();
  document.addEventListener("DOMContentLoaded", tryInit);
  const observer = new MutationObserver(tryInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
